import { apiGateway } from "@contexts";
import type { Patient } from "@interfaces";
import { useMutation } from "@tanstack/react-query";

const getPatientByDocumentFn = (documentNumber: string | null) => {
  return apiGateway<{ patient: Patient }>({
    url: `/clinical-history/patients/by-document/${documentNumber}`,
    method: "GET",
  });
};

export const useGetPatientByDocument = () => {
  return useMutation({
    mutationFn: async (documentNumber: string | null) => {
      const response = await getPatientByDocumentFn(documentNumber);

      return response.patient;
    },
  });
};
